import { z } from 'zod'

export const moneyField = z.union([
  z.number(),
  z.string().transform((v) => {
    const cleaned = v.replace(/\s/g, '').replace(/,/g, '')
    const parsed = Number(cleaned)
    if (Number.isNaN(parsed)) throw new Error('Invalid number')
    return parsed
  }),
])

export function positiveMoney(message = 'Enter a positive amount') {
  return moneyField.refine((v) => v >= 0, { message }).transform((v) => Number(v))
}

export function positivePercent(fieldName = 'value') {
  return z
    .number()
    .min(0, { message: `${fieldName} must be at least 0%` })
    .max(1, { message: `${fieldName} must be at most 100%` })
}

export function positiveInteger(message = 'Enter a positive whole number') {
  return z.number().int().nonnegative({ message })
}
